module.exports = __webpack_public_path__ + "media/images/icon_ticket-2313ee1fbae04c0544ff4d091cd52291.svg";